import { render, staticRenderFns } from "./CardListModal.vue?vue&type=template&id=5d8656e4&"
import script from "./CardListModal.vue?vue&type=script&lang=js&"
export * from "./CardListModal.vue?vue&type=script&lang=js&"
import style0 from "./CardListModal.vue?vue&type=style&index=0&id=5d8656e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports